module.exports = __webpack_public_path__ + "images/powerups/card-aging/screenshots/2015-3-23-screenshot1.27972dcff7cab11886b6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/powerups/card-aging/screenshots/2015-3-23-screenshot1.png
// module id = +h7p
// module chunks = 0